if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      if (this.classList.contains('sticky-atc-panel-hide-mobile')) {
        document.body.classList.add('body-sticky-atc-panel-hide-mobile');
      }
    }

    bindEvents() {
      const productReviews = document.querySelector('.product-info__title #product_just_stars');
      const productReviewsSticky = document.querySelector('.sticky-atc-panel-reviews');

      function initReviews() {
        productReviewsSticky.innerHTML = '';
        productReviewsSticky.appendChild(productReviews.cloneNode(true));

        const productReviewsLink = productReviews.querySelector('a.sa_jump_to_reviews');
        const productReviewsLinksSticky = productReviewsSticky.querySelectorAll('.sa_jump_to_reviews');

        if (productReviewsLink && productReviewsLinksSticky) {
          productReviewsLinksSticky.forEach((link) => {
            link.addEventListener('click', (e) => {
              e.preventDefault();

              productReviewsLink.click();
            });
          });
        }
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom < 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', !entry.isIntersecting);
          }

          if (productReviews && productReviewsSticky) {
            initReviews();
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      this.removeAttribute('hidden');
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
